export const DATE_PERIODS_TYPES = {
   DAY: "day",
   WEEK: "week",
   MONTH: "month",
   YEAR: "year",
}

export const PERIODS_TYPES = {
   AUTO: "auto",
   COMBINED: "combined",
}
